// @todo: Remove experimental_ when upgrade to MUI v7
import { createTheme, Theme } from "@mui/material/styles";
import palette from "./palette";
import { typography, MuiTypography } from "./typography";
import { MuiAlert } from "./alert";
import { MuiButton, MuiToggleButton } from "./button";
import { MuiCheckbox } from "./checkbox";
import { MuiDialogTitle, MuiDialogContent, MuiDialogActions } from "./dialog";
import { MuiFormControlLabel, MuiFormLabel } from "./form";
import { MuiInputBase, MuiFilledInput, MuiOutlinedInput } from "./input";
import { MuiMenuItem } from "./menu";
import { MuiRadio } from "./radio";
import { MuiSlider } from "./slider";
import { MuiStepper, MuiStep, MuiStepLabel, MuiStepConnector, MuiStepIcon } from "./stepper";
import { MuiTableHead, MuiTableRow, MuiTableCell } from "./table";
import { MuiTooltip } from "./tooltip";

export const theme = createTheme({
  // @todo: Enable this once upgraded to MUI v7
  // cssVariables: true,
  shape: {
    borderRadius: 5,
  },
  palette,
  typography,
  components: {
    MuiTypography,
    MuiAlert,
    MuiButton,
    MuiCheckbox,
    MuiDialogTitle,
    MuiDialogContent,
    MuiDialogActions,
    MuiFilledInput,
    MuiFormControlLabel,
    MuiFormLabel,
    MuiInputBase,
    MuiMenuItem,
    MuiOutlinedInput,
    MuiRadio,
    MuiSlider,
    MuiStepper,
    MuiStep,
    MuiStepLabel,
    MuiStepConnector,
    MuiStepIcon,
    MuiTableHead,
    MuiTableRow,
    MuiTableCell,
    MuiToggleButton,
    MuiTooltip,
  },
});

// If you need to export the theme type
export type AppTheme = Theme;
